export const IS_DEVELOPMENT = import.meta.env.MODE === "development";
export const PLATFORM_URL = window.__APP_CONFIG__.APP_PLATFORM_URL;
export const BN_BACKEND_URL = window.__APP_CONFIG__.APP_BN_BACKEND_URL;
export const BN_BACKEND_AUTH_URL = window.__APP_CONFIG__.APP_BN_BACKEND_AUTH_URL;
export const AIODP_URL = window.__APP_CONFIG__.APP_AIODP_URL;
export const DEPLOYAI_URL_IMPRINT = window.__APP_CONFIG__.APP_DEPLOYAI_URL_IMPRINT;
export const DEPLOYAI_URL_TERMS_AND_CONDITIONS = window.__APP_CONFIG__.APP_DEPLOYAI_URL_TERMS_AND_CONDITIONS;
export const DEPLOYAI_URL_PRIVACY_POLICY = window.__APP_CONFIG__.APP_DEPLOYAI_URL_PRIVACY_POLICY;
export const DEPLOYAI_URL_PARTNERS_PAGE = window.__APP_CONFIG__.APP_DEPLOYAI_URL_PARTNERS_PAGE;
export const APP_GA_MEASUREMENT_ID = window.__APP_CONFIG__.APP_GA_MEASUREMENT_ID;
export const CONTACT_US_LINK = window.__APP_CONFIG__.APP_CONTACT_US_LINK;

